export function Input(props) {
  return <input {...props} className={`input-old ${props.className}`} data-test-id={props['data-test-id']} />;
}
